import React from 'react';
import TableView from '@/common/components/TableView/CustomTableView';
import { Grid, Button } from '@mui/material';
import { columns, reportFileName } from './constants/constants';
import CreateEditSecondaryCustomerMaster from 
'./create-edit-secondary-customer-master/create-edit-secondary-customer-master';
import ModalDialog from '@/common/components/modal-dialog/modal-dialog';
import useSecondaryCustomerMaster from './hooks/useSecondaryCustomerMaster';
import useOnActions from './hooks/useOnActions';
import AlertDialog from '@/common/components/alert-dialog/alert-dialog';
import { requestedMenuAll, requestedFeaturesAll } from '@/from-theme/routes/constants/menuAccess';
import { isUserHasAccess } from '@/from-theme/utils/route-guard/helpers/helpers';
import useAuth from '@/from-theme/hooks/useAuth';
import MainCard from '@/from-theme/components/MainCard';
import Dropdown from '@/common/components/dropdown/dropdown';
import { FormattedMessage } from 'react-intl';
import useGetDistrictMasterByState from '@/common/hooks/useGetDistrictByState';
import useGetCityMasterByDistrict from '@/common/hooks/useGetCityByDistrict';
import useGetSubZoneOptions from '@/common/hooks/useGetSubZoneMaster';

const { secondCustTabMasterKey } = requestedMenuAll;
const { updateKey, deleteKey } = requestedFeaturesAll;

export default function SecondaryCustomer() {

  const { getFoodsSubZoneOptions, getSubZoneRawData, getSubZoneLoading } = useGetSubZoneOptions();

  const {
    getDistrictsByStateOptions: districtsData,
    getDistrictsByState: getDistrict,
    getDistrictsByStateLoading: districtsLoading
  } = useGetDistrictMasterByState('stateId');
  const {
    getCitysByDistrictOptions: citiesData,
    getCitysByDistrict: getCity,
    getCitysByDistrictLoading: citiesLoading
  } = useGetCityMasterByDistrict('district');

  const {
    secondaryCustomerMasterData,
    isCreateEditModalOpen,
    onRowEdit,
    values,
    formik,
    activeEditId,
    closeModal,
    secondaryCustomerMasterStatus,
    secondaryCustomerMasterErrMsg
  } = useSecondaryCustomerMaster({getDistrict, getCity, getSubZoneRawData});
  const { subzoneId, districtId, cityId } = values;
  const { userData } = useAuth();
  const entitlement = userData?.entitlement || {};

  const isUpdateDeleteAccess =
    isUserHasAccess(secondCustTabMasterKey, updateKey, entitlement) || 
    isUserHasAccess(secondCustTabMasterKey, deleteKey, entitlement);

  const { onRowDelete, deleteSecondaryCustomerMasterStatus, isAlertDialog, 
    onCloseAlert, onAgreeAlert } = useOnActions();

  return (
    <MainCard>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Dropdown
              options={getFoodsSubZoneOptions}
              loading={getSubZoneLoading}
              placeholder="subzone-name"
              inputLabel="subzone-name"
              value={subzoneId}
              formik={formik}
              name="subzoneId"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Dropdown
              options={districtsData}
              loading={districtsLoading}
              placeholder="district-name"
              inputLabel="district-name"
              value={districtId}
              formik={formik}
              name="districtId"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Dropdown
              options={citiesData}
              loading={citiesLoading}
              placeholder="city-name"
              inputLabel="city-name"
              value={cityId}
              formik={formik}
              name="cityId"
              isCheckBox
              multiple
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2} lg={2} style={{ paddingTop: '45px' }}>
            <Button type="submit" variant="contained" size="small">
              <FormattedMessage id="search" />
            </Button>
          </Grid>
        </Grid>
      </form>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TableView
            data={secondaryCustomerMasterData}
            columns={columns({ onRowEdit, onRowDelete, deleteSecondaryCustomerMasterStatus, 
              isUpdateDeleteAccess })}
            reportFileName={reportFileName}
            apiStatus={secondaryCustomerMasterStatus}
            apiErrorMsg={secondaryCustomerMasterErrMsg}
            stringInExport={['activeStatus']}
          />
          {isCreateEditModalOpen && (
            <ModalDialog
              closeModal={() => closeModal()}
              modalTitle={!activeEditId ? 'create-secondary-customer-master' : 
                'edit-secondary-customer-master'}
              fullScreen
            >
              <CreateEditSecondaryCustomerMaster closeModal={() => closeModal()} 
              activeEditId={activeEditId} />
            </ModalDialog>
          )}
          {isAlertDialog && <AlertDialog onCloseAlert={onCloseAlert} onAgreeAlert={onAgreeAlert} />}
        </Grid>
      </Grid>
    </MainCard>
  );
}
